import { z } from 'zod'

import {
  metricBatchSchema,
  metricsListArgsSchema,
  metricSchema,
  metricsListAggregateSchema,
  metricsListResponseSchema,
  reservationMeasuresSchema,
  admissionMeasuresSchema,
  ticketMeasuresSchema,
  guestlistMeasuresSchema,
  tallyMeasuresSchema,
  leadsMeasuresSchema,
  inventoryMeasuresSchema,
  inventoryPriceMeasuresSchema,
  purchaseDateMeasuresSchema,
  dayOfWeekMeasuresSchema,
  recurringIdentifierMeasuresSchema,
  admissionGroupMeasuresSchemaBase,
  customerMeasuresSchema,
  trackingEventsEntityMeasuresSchema,
  trackingEventsMeasuresSchema,
  admissionGroupMeasuresSchema,
  organizationMeasuresSchema,
  platformVenueMeasuresSchema,
  aggregateByInventoryPriceItemSchema,
  aggregateByPurchaseDateItemSchema,
  aggregateByDayOfWeekItemSchema,
  aggregateByRecurringIdentifierItemSchema,
  upcomingPipelineArgsSchema,
  upcomingPipelineAggregateSchema,
  upcomingPipelineResponseSchema,
  upcomingPipelineDaySchema,
} from './schemas/metric'

export type Metric = z.infer<typeof metricSchema>
export type MetricBatch = z.infer<typeof metricBatchSchema>

export type MetricListArgs = z.infer<typeof metricsListArgsSchema>

export type MetricsListResponse = z.infer<typeof metricsListResponseSchema>
export type MetricsListAggregate = z.infer<typeof metricsListAggregateSchema>

export type ReservationMeasures = z.infer<typeof reservationMeasuresSchema>
export type AdmissionMeasures = z.infer<typeof admissionMeasuresSchema>
export type TicketMeasures = z.infer<typeof ticketMeasuresSchema>
export type GuestlistMeasures = z.infer<typeof guestlistMeasuresSchema>
export type TallyMeasures = z.infer<typeof tallyMeasuresSchema>
export type LeadsMeasures = z.infer<typeof leadsMeasuresSchema>
export type InventoryMeasures = z.infer<typeof inventoryMeasuresSchema>
export type InventoryPriceMeasures = z.infer<
  typeof inventoryPriceMeasuresSchema
>
export type PurchaseDateMeasures = z.infer<typeof purchaseDateMeasuresSchema>
export type DayOfWeekMeasures = z.infer<typeof dayOfWeekMeasuresSchema>
export type RecurringIdentifierMeasures = z.infer<
  typeof recurringIdentifierMeasuresSchema
>
export type AggregateByInventoryPriceItem = z.infer<
  typeof aggregateByInventoryPriceItemSchema
>
export type AggregateByPurchaseDateItem = z.infer<
  typeof aggregateByPurchaseDateItemSchema
>
export type AggregateByDayOfWeekItem = z.infer<
  typeof aggregateByDayOfWeekItemSchema
>
export type AggregateByRecurringIdentifierItem = z.infer<
  typeof aggregateByRecurringIdentifierItemSchema
>

export type UpcomingPipelineArgs = z.infer<typeof upcomingPipelineArgsSchema>
export type UpcomingPipelineDay = z.infer<typeof upcomingPipelineDaySchema>
export type UpcomingPipelineAggregate = z.infer<
  typeof upcomingPipelineAggregateSchema
>
export type UpcomingPipelineResponse = z.infer<
  typeof upcomingPipelineResponseSchema
>

export type AdmissionGroupMeasures = z.infer<
  typeof admissionGroupMeasuresSchema
>

export type AttributionMeasures = {
  attributionId?: string
  attributionName?: string
  attributionType?: string
  totalPaymentLinks?: number
} & Omit<
  AdmissionGroupMeasures,
  | 'byInventory'
  | 'byAttributionId'
  | 'byInventoryPrice'
  | 'byPurchaseDate'
  | 'byDayOfWeek'
  | 'byRecurringIdentifier'
>

export type CustomerMeasures = z.infer<typeof customerMeasuresSchema>
export type TrackingEventsEntityMeasures = z.infer<
  typeof trackingEventsEntityMeasuresSchema
>
export type TrackingEventsMeasures = z.infer<
  typeof trackingEventsMeasuresSchema
>
export type OrganizationMeasures = z.infer<typeof organizationMeasuresSchema>
export type PlatformVenueMeasures = z.infer<typeof platformVenueMeasuresSchema>

export { metricsListResponseSchema } from './schemas/metric'
